import { render, staticRenderFns } from "./data47.vue?vue&type=template&id=4978d033&scoped=true"
import script from "./data47.vue?vue&type=script&lang=js"
export * from "./data47.vue?vue&type=script&lang=js"
import style1 from "./data47.vue?vue&type=style&index=1&id=4978d033&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4978d033",
  null
  
)

export default component.exports